import { Injectable } from '@angular/core';
import { optimizeIcon } from '@app/shared/helpers/custom-svg-icons';
import * as allSvgIcons from '@progress/kendo-svg-icons';
import { OptinexUserDTO } from '../http-services/common/user.service';
import { DrawerItem } from '@progress/kendo-angular-layout';
import { _ } from '@ngx-translate/core';

_([
  'AppComponent.Admin',
  'AppComponent.Admin_Entity',
  'AppComponent.Admin_EntityActivity',
  'AppComponent.Admin_EntityResource',
  'AppComponent.Admin_EntityGroup',
  'AppComponent.Admin_EntityProperty',
  'AppComponent.Admin_Model',
  'AppComponent.Analytics',
  'AppComponent.Beams',
  'AppComponent.General_Dashbord',
  'AppComponent.Glue_Plans',
  'AppComponent.Gluing_Plan',
  'AppComponent.Glulam_Operator',
  'AppComponent.Glulam_Planning',
  'AppComponent.Glulam_Planning_Legacy',
  'AppComponent.Glulam_Planning_Statical',
  'AppComponent.Glulam_Scheduler_Statical',
  'AppComponent.Log_Class',
  'AppComponent.Models',
  'AppComponent.Operational_Dashbord',
  'AppComponent.Optimization',
  'AppComponent.Pattern_Analysis',
  'AppComponent.Production_Order',
  'AppComponent.Production_Order_Schedule',
  'AppComponent.Production_Order_Gantt',
  'AppComponent.Reports',
  'AppComponent.Saw_Pattern',
  'AppComponent.Settings',
  'AppComponent.Tactical_Dashbord',
  'AppComponent.Availability',
  'AppComponent.AoT_Balance',
  'AppComponent.AoT_Balance_Report',
  'AppComponent.Glulam',
  'AppComponent.Glulam',
  'AppComponent.Machine',
  'AppComponent.Operative',
  'AppComponent.Model',
  'AppComponent.Stock',
  'AppComponent.Stock_Location',
  'AppComponent.Stock_Trans_Type',
  'AppComponent.CLT',
  'AppComponent.Plan',
  'AppComponent.MachineGroup',
  'AppComponent.Handeling_Unit_Report',
  'AppComponent.Schedule',
  'AppComponent.Shift',
  'AppComponent.Deviation',
  'AppComponent.Demand_Report',
  'AppComponent.Device',
  'AppComponent.OptimizeSequencer',
  'AppComponent.LogForecast',
  'AppComponent.Production_Order_ScheduleNg',
  'AppComponent.OptimizeRuns',
  'AppComponent.Instruction',
  'AppComponent.InstructionLine',
  'AppComponent.Parts',
  'AppComponent.Part',
  'AppComponent.Profile',
  'AppComponent.ShapeList',
  'AppComponent.EditMotherBoard',
  'AppComponent.EditProfileView',
  'AppComponent.PlanView',
  'AppComponent.EditPlan',
  'AppComponent.EditProfile',
  'AppComponent.Tactical',
  'AppComponent.Users',
  'AppComponent.GLT_Dashbord',
  'AppComponent.BudgetItems',
  'AppComponent.Budget',
  'AppComponent.PeriodBounds',
  'AppComponent.Available_Machine_Time',
  'AppComponent.Markets',
  'AppComponent.Kiln_Planning',
  'AppComponent.OptimizationScope',
]);

@Injectable({
  providedIn: 'root',
})
export class MenuItemService {
  filterNodesByUser(user: OptinexUserDTO): Array<AppDrawerItem> {
    return this.nodes.filter(function f(o) {
      if (user.isCrossTenantAdmin && o.forCrossTenantAdmin) {
        return true;
      }

      if (user.isSingleTenantAdmin && o.forSingleTenantAdmin) {
        return true;
      }

      if (user.isDeveloper && o.forDeveloper) {
        return true;
      }

      if (user.isPlanner && o.forPlanner) {
        return true;
      }

      if (user.isOperator && o.forOperator) {
        return true;
      }

      return false;
    });
  }

  public nodes: Array<AppDrawerItem> = [
    {
      text: 'AppComponent.Analytics',
      svgIcon: allSvgIcons.chartAreaStackedIcon,
      id: 1,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Glulam',
      svgIcon: allSvgIcons.chartAreaStackedIcon,
      path: 'dashboard/4',
      id: 2,
      parentId: 1,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Operative',
      svgIcon: allSvgIcons.chartAreaStackedIcon,
      path: 'dashboard/1',
      id: 3,
      parentId: 1,
      forDeveloper: true,
    },

    { separator: true },

    {
      text: 'AppComponent.Availability',
      svgIcon: allSvgIcons.chartRadarMarkersIcon,
      id: 5,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.AoT_Balance',
      svgIcon: allSvgIcons.chartRadarMarkersIcon,
      id: 6,
      path: 'aot/balance',
      parentId: 5,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.AoT_Balance_Report',
      svgIcon: allSvgIcons.chartRadarMarkersIcon,
      id: 7,
      path: 'aot/balanceReport',
      parentId: 5,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Demand_Report',
      svgIcon: allSvgIcons.chartRadarMarkersIcon,
      id: 8,
      path: 'aot/demand',
      parentId: 5,
      forDeveloper: true,
      forPlanner: true,
    },

    { separator: true },

    {
      text: 'AppComponent.Model',
      svgIcon: allSvgIcons.buildingBlocksIcon,
      id: 11,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Admin_EntityActivity',
      svgIcon: allSvgIcons.buildingBlocksIcon,
      id: 12,
      path: 'model/entity/activity',
      parentId: 11,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Admin_EntityResource',
      svgIcon: allSvgIcons.buildingBlocksIcon,
      id: 13,
      path: 'model/entity/material',
      parentId: 11,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Admin_EntityGroup',
      svgIcon: allSvgIcons.buildingBlocksIcon,
      id: 14,
      path: 'model/entity-group',
      parentId: 11,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Admin_EntityProperty',
      svgIcon: allSvgIcons.buildingBlocksIcon,
      id: 15,
      path: 'model/entity-property',
      parentId: 11,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.ExcelImportExport',
      svgIcon: allSvgIcons.buildingBlocksIcon,
      id: 59,
      parentId: 11,
      path: 'model/import-excel',
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'Model.MaterialConfigurationValidation',
      svgIcon: allSvgIcons.warningTriangleIcon,
      id: 63,
      path: 'model/material-config-validation',
      parentId: 11,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'Model.ActivityRelationProdOrderList.ActivityRelationUpdate',
      svgIcon: allSvgIcons.buildingBlocksIcon,
      id: 67,
      path: 'model/activity-relation-update',
      parentId: 11,
      forDeveloper: true,
      forPlanner: true,
    },

    { separator: true },

    {
      text: 'EntityTranslation.Tactical',
      svgIcon: allSvgIcons.arrowsAxesIcon,
      id: 17,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Plan',
      svgIcon: allSvgIcons.arrowsAxesIcon,
      id: 18,
      path: 'tactical/plan',
      parentId: 17,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.PeriodBounds',
      svgIcon: allSvgIcons.arrowsAxesIcon,
      id: 61,
      path: 'tactical/period-bound',
      parentId: 17,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.ActivityBounds',
      svgIcon: allSvgIcons.arrowsAxesIcon,
      id: 64,
      path: 'tactical/period-bound-activity',
      parentId: 17,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Budget',
      svgIcon: allSvgIcons.arrowsAxesIcon,
      id: 56,
      path: 'tactical/budget',
      parentId: 17,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Stock',
      svgIcon: allSvgIcons.arrowsAxesIcon,
      id: 57,
      path: 'tactical/stock',
      parentId: 17,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Available_Machine_Time',
      svgIcon: allSvgIcons.arrowsAxesIcon,
      id: 58,
      path: 'tactical/available-machine-time',
      parentId: 17,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Markets',
      svgIcon: allSvgIcons.arrowsAxesIcon,
      id: 66,
      path: 'tactical/markets',
      parentId: 17,
      forDeveloper: true,
      forPlanner: true,
    },

    { separator: true },

    { text: 'AppComponent.Saw_Pattern', svgIcon: allSvgIcons.cutIcon, id: 19, path: 'saw-pattern', forDeveloper: true },

    { separator: true },

    {
      text: 'AppComponent.Glulam',
      svgIcon: allSvgIcons.alignItemsStartIcon,
      id: 20,
      forDeveloper: true,
      forPlanner: true,
      forOperator: true,
    },
    {
      text: 'AppComponent.Glue_Plans',
      svgIcon: allSvgIcons.alignItemsStartIcon,
      id: 25,
      path: 'glulam/glueplans',
      parentId: 20,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Glulam_Planning',
      svgIcon: allSvgIcons.alignItemsStartIcon,
      id: 21,
      path: 'glulam/continuous',
      parentId: 20,
      forDeveloper: true,
      forPlanner: true,
    },

    {
      text: 'AppComponent.Glulam_Planning_Legacy',
      svgIcon: allSvgIcons.alignItemsStartIcon,
      id: 21,
      path: 'glulam',
      parentId: 20,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Glulam_Planning_Statical',
      svgIcon: allSvgIcons.alignItemsStartIcon,
      id: 22,
      path: 'glulam/statical',
      parentId: 20,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Glulam_Scheduler_Statical',
      svgIcon: allSvgIcons.alignItemsStartIcon,
      id: 56,
      path: 'glulam/statical/scheduler-v2',
      parentId: 20,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Glulam_Operator',
      svgIcon: allSvgIcons.alignItemsStartIcon,
      id: 23,
      path: 'glulam/operator',
      parentId: 20,
      forDeveloper: true,
      forPlanner: true,
      forOperator: true,
    },
    {
      text: 'AppComponent.Beams',
      svgIcon: allSvgIcons.alignItemsStartIcon,
      id: 24,
      path: 'glulam/beams',
      parentId: 20,
      forDeveloper: true,
      forPlanner: true,
      forOperator: true,
    },

    { separator: true },

    {
      text: 'AppComponent.Optimization',
      svgIcon: optimizeIcon,
      id: 27,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.OptimizeRuns',
      svgIcon: optimizeIcon,
      id: 28,
      path: 'optimization/runs',
      parentId: 27,
      forDeveloper: true,
      forPlanner: true,
    },

    {
      text: 'AppComponent.OptimizationScope',
      svgIcon: optimizeIcon,
      id: 65,
      path: 'tactical/entity-group-scope',
      parentId: 27,
      forDeveloper: true,
      forPlanner: true,
    },

    { separator: true },

    { text: 'AppComponent.CLT', svgIcon: allSvgIcons.tableRowGroupsIcon, id: 29, forDeveloper: true },
    {
      text: 'AppComponent.ShapeList',
      svgIcon: allSvgIcons.tableRowGroupsIcon,
      id: 30,
      path: 'clt/shape-list',
      parentId: 29,
      forDeveloper: true,
    },
    {
      text: 'AppComponent.PlanList',
      svgIcon: allSvgIcons.tableRowGroupsIcon,
      id: 31,
      path: 'clt/plan-list',
      parentId: 29,
      forDeveloper: true,
    },
    {
      text: 'AppComponent.ProfileList',
      svgIcon: allSvgIcons.tableRowGroupsIcon,
      id: 32,
      path: 'clt/profile-list',
      parentId: 29,
      forDeveloper: true,
    },
    {
      text: 'AppComponent.EditProfile',
      svgIcon: allSvgIcons.tableRowGroupsIcon,
      id: 35,
      path: 'clt/edit-profile',
      parentId: 29,
      forDeveloper: true,
    },

    { separator: true },

    {
      text: 'AppComponent.Operative',
      svgIcon: allSvgIcons.calendarIcon,
      id: 36,
      forDeveloper: true,
      forPlanner: true,
      forOperator: true,
    },
    {
      text: 'AppComponent.Production_Order',
      svgIcon: allSvgIcons.calendarIcon,
      id: 37,
      path: 'operative/prod-order',
      parentId: 36,
      forDeveloper: true,
      forPlanner: true,
      forOperator: true,
    },
    {
      text: 'AppComponent.Production_Order_ScheduleNg',
      svgIcon: allSvgIcons.calendarIcon,
      id: 38,
      path: 'operative/prod-order-schedule-ng',
      parentId: 36,
      forDeveloper: true,
      forPlanner: true,
      forOperator: true,
    },
    {
      text: 'AppComponent.Machine',
      svgIcon: allSvgIcons.calendarIcon,
      id: 40,
      path: 'operative/machine',
      parentId: 36,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.MachineGroup',
      svgIcon: allSvgIcons.calendarIcon,
      id: 41,
      path: 'operative/machine-group',
      parentId: 36,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Instruction',
      svgIcon: allSvgIcons.calendarIcon,
      id: 42,
      path: 'operative/instruction',
      parentId: 36,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Schedule',
      svgIcon: allSvgIcons.calendarIcon,
      id: 44,
      path: 'operative/schedule',
      parentId: 36,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Shift',
      svgIcon: allSvgIcons.calendarIcon,
      id: 45,
      path: 'operative/shift',
      parentId: 36,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Deviation',
      svgIcon: allSvgIcons.calendarIcon,
      id: 46,
      path: 'operative/deviation',
      parentId: 36,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Kiln_Planning',
      svgIcon: allSvgIcons.calendarIcon,
      id: 62,
      path: 'operative/kiln-planning',
      parentId: 36,
      forDeveloper: true,
      forPlanner: true,
      forOperator: true,
    },
    { separator: true },

    {
      text: 'AppComponent.Stock',
      svgIcon: allSvgIcons.alignJustifyIcon,
      id: 48,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Stock_Location',
      svgIcon: allSvgIcons.barcodeOutlineIcon,
      id: 49,
      path: 'stock/stocklocation',
      parentId: 48,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Stock_Trans_Type',
      svgIcon: allSvgIcons.barcodeOutlineIcon,
      id: 50,
      path: 'stock/stocktranstype',
      parentId: 48,
      forDeveloper: true,
      forPlanner: true,
    },
    {
      text: 'AppComponent.Handeling_Unit_Report',
      svgIcon: allSvgIcons.barcodeOutlineIcon,
      id: 51,
      path: 'stock/handeling-unit',
      parentId: 48,
      forDeveloper: true,
      forPlanner: true,
    },

    { separator: true },

    {
      text: 'AppComponent.Reports',
      svgIcon: allSvgIcons.clipboardTextIcon,
      id: 53,
      path: 'report',
      forDeveloper: true,
      forPlanner: true,
    },

    { separator: true },

    {
      text: 'AppComponent.Admin',
      svgIcon: allSvgIcons.clipboardTextIcon,
      id: 54,
      forDeveloper: true,
      forCrossTenantAdmin: true,
      forSingleTenantAdmin: true,
    },
    {
      text: 'AppComponent.Users',
      svgIcon: allSvgIcons.clipboardTextIcon,
      id: 55,
      path: 'user-admin',
      forDeveloper: true,
      forCrossTenantAdmin: true,
      forSingleTenantAdmin: true,
      parentId: 54,
    },
    {
      text: 'AppComponent.Availability',
      svgIcon: allSvgIcons.chartRadarMarkersIcon,
      id: 68,
      forDeveloper: true,
      forCrossTenantAdmin: true,
      forSingleTenantAdmin: true,
      parentId: 54,
    },
    {
      text: 'AoT.LogForecast',
      svgIcon: allSvgIcons.chartRadarMarkersIcon,
      id: 9,
      path: 'aot/logForecast',
      forDeveloper: true,
      forCrossTenantAdmin: true,
      forSingleTenantAdmin: true,
      parentId: 68,
    },
    {
      text: 'AoT.Templates',
      svgIcon: allSvgIcons.chartRadarMarkersIcon,
      id: 10,
      path: 'aot/templates',
      forDeveloper: true,
      forCrossTenantAdmin: true,
      forSingleTenantAdmin: true,
      parentId: 68,
    },
    {
      text: 'SupplyProviderConfig.Title',
      svgIcon: allSvgIcons.chartRadarMarkersIcon,
      id: 67,
      path: 'aot/supply-provider-config',
      forDeveloper: true,
      forCrossTenantAdmin: true,
      forSingleTenantAdmin: true,
      parentId: 68,
    },
    {
      text: 'AppComponent.Tactical',
      svgIcon: allSvgIcons.clipboardTextIcon,
      id: 65,
      path: 'dashboard/2',
      forDeveloper: true,
      forCrossTenantAdmin: true,
      forSingleTenantAdmin: true,
      parentId: 1,
    },
  ];
}

export interface AppDrawerItem extends DrawerItem {
  path?: string;
  forCrossTenantAdmin?: boolean;
  forSingleTenantAdmin?: boolean;
  forDeveloper?: boolean;
  forPlanner?: boolean;
  forOperator?: boolean;
  expanded?: boolean;
}
